import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Loading } from "../../components/widgets";
import MFASettingsForm from "../../components/user/MFASettingsForm";
import * as userActions from "../../redux/actions/user";

const mapStateToProps = state => ({
  mfaSettings: state.user.mfaSettings,
  codePreference: state.user.codePreference,
});

const mapDispatchToProps = dispatch => {
  return {
    userActions: bindActionCreators(userActions, dispatch),
  };
};

class MFASettings extends Component {
  constructor(props) {
    super(props);

    this.state = {
      password: "",
      verificationCode: "",
    };
  }

  componentDidMount = () => {
    this.props.userActions.fetchMFASettings();

    if (this.props.mfaSettings) {
      this.setState({
        codePreference: this.props.mfaSettings.codePreference,
      });
    }
  };

  componentWillReceiveProps = nextProps => {
    if (this.props.mfaSettings !== nextProps.mfaSettings) {
      this.setState({
        codePreference: nextProps.mfaSettings.codePreference,
      });
    }
  };

  handleCodePreferenceChange = preference => {
    this.setState({
      codePreference: preference.value,
    });
  };

  handlePhoneNumberChange = event => {
    const phoneNumber = event.target.value;
    this.setState({
      phoneNumber: phoneNumber,
      error: phoneNumber ? null : this.state.error,
    });
  };

  handleConfirmPasswordChange = event => {
    this.setState({
      password: event.target.value,
    });
  };

  handleVerificationCodeChange = event => {
    this.setState({
      verificationCode: event.target.value,
    });
  };

  handleOnSave = () => {
    if (this.props.mfaSettings.codePreference !== this.state.codePreference) {
      this.props.userActions.fetchSaveCodePreference(this.state.codePreference);
    }
  };

  render() {
    return (
      <div className="user-setting mfa">
        <h4>Multi-Factor Authentication (MFA)</h4>
        {!this.props.mfaSettings ? (
          <div style={{ margin: "2em", position: "relative" }}>
            <Loading />
          </div>
        ) : (
          <MFASettingsForm
            codePreference={this.state.codePreference}
            onCodePreferenceChange={this.handleCodePreferenceChange}
            saveEnabled={this.props.mfaSettings.codePreference !== this.state.codePreference}
            onPhoneNumberChange={this.handlePhoneNumberChange}
            phoneNumber={this.state.phoneNumber}
            phoneNumberConfirmed={this.props.mfaSettings.phoneNumberConfirmed}
            phoneNumberMasked={this.props.mfaSettings.phoneNumberMasked}
            onConfirmPasswordChange={this.handleConfirmPasswordChange}
            password={this.state.password}
            onSave={this.handleOnSave}
            loading={this.props.codePreference ? this.props.codePreference.fetching : false}
            passwordError={this.state.passwordError}
          />
        )}
      </div>
    );
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(MFASettings);
